import React from 'react'
import { Switch, Route } from 'react-router-dom'

// Pages components
import Home from './pages/Home'
import Test from './pages/Test'
import Login from './pages/Login'
import User from './pages/User'
import Personalities from './pages/Personalities'
import Bars from './pages/Bars'
import Profile from './pages/Profile'

import AllUsers from './admin/AllUsers'
import UsersFormEdit from './admin/UsersFormEdit'

// Complimentary components
// import Ques from './components/test/Ques'
// import Top5 from './components/types/Top5'
// import Forydeb from './components/types/Forydeb'
// import Description from './components/types/Description'

import Questions from './admin/Questions'
import QuestionCreate from './admin/QuestionCreate'
import QuestionEdit from './admin/QuestionEdit'
import Categories from './admin/Categories'
import CategoryCreate from './admin/CategoryCreate'
import CategoryEdit from './admin/CategoryEdit'

import UsersMassive from './admin/UsersMassive'



// The Main component renders one of the three provided
// Routes (provided that one matches). Both the /roster
// and /schedule routes will match any pathname that starts
// with /roster or /schedule. The / route will only match
// when the pathname is exactly the string "/"
const Main = () => (
  <main className="main">
    <Switch>

      <Route exact path='/' component={Home}/>
      <Route exact path='/test' component={Test}/>
      <Route exact path='/personalities' component={Personalities}/>
      <Route exact path='/mypersonality' component={Bars}/>
      
      <Route exact path='/bars/:id' component={Bars}/>
      <Route exact path='/bars/:id/profile' component={Profile}/>
      <Route exact path='/bars/:id/descripcion' component={Profile}/>
      <Route exact path='/bars/:id/fortalezas-debilidades' component={Profile}/>
      <Route exact path='/bars/:id/carreras-top' component={Profile}/>

      <Route exact path='/admin/users/massive' component={UsersMassive}/>
      <Route exact path='/admin/users/:id' component={UsersFormEdit}/>

      <Route exact path='/admin/questions' component={Questions}/>
      <Route exact path='/admin/questions/create' component={QuestionCreate}/>
      <Route exact path='/admin/questions/:id/edit' component={QuestionEdit}/>
      <Route exact path='/admin/categories' component={Categories}/>
      <Route exact path='/admin/categories/create' component={CategoryCreate}/>
      <Route exact path='/admin/categories/:id/edit' component={CategoryEdit}/>

      <Route exact path='/admin/users' component={AllUsers}/>


      <Route exact path='/login' component={Login}/>
      <Route exact path='/user' component={User}/>
      <Route exact path='/logout' component={ (props) => {
        localStorage.removeItem('tpuser')
        props.history.push('/');
        return <Login />;
      }} />

    </Switch>
  </main>
)

export default Main



// WEBPACK FOOTER //
// ./src/Main.js